// extracted by mini-css-extract-plugin
export default {"container":"HorseBodyMapTab_container__0bpPK","content":"HorseBodyMapTab_content__lL9Po"};